import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CurrencyPicker from '../../common/CurrencyPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSideNav = ({
  selectedNavItem,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close the nav when the route changes (user selected an item)
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "300",
    paddingBlock: "300",
    backgroundColor: "fill-surface-default",
    boxShadow: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Button, {
        use: "transparent",
        "aria-expanded": isOpen,
        "aria-controls": "mobile-side-nav-list",
        onClick: () => setIsOpen(prev => !prev),
        "data-test-id": "side-nav-mobile-toggle",
        paddingInlineStart: "0",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.pages.products.tabs.${selectedNavItem}.tabTitle`
            })
          }), /*#__PURE__*/_jsx(DownCaratIcon, {
            size: "100"
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        flexShrink: 0,
        maxInlineSize: "120px",
        children: /*#__PURE__*/_jsx(CurrencyPicker, {})
      })]
    }), isOpen && /*#__PURE__*/_jsx(View, {
      id: "mobile-side-nav-list",
      paddingBlockStart: "300",
      children: children
    })]
  });
};
export default MobileSideNav;